import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};

const MDXLayout = function Layout({
  children
}) {
  return <>
      {children}
    </>;
};

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Frequently Asked Questions`}</h2>
    <h3>{`Why Gatsby?`}</h3>
    <p>{`Gatsby delivers faster, more secure sites and apps from a variety of data
sources`}</p>
    <h3>{`Where do I start?`}</h3>
    <p>{`The documentation offers guides for all different skill levels, you can
find more info at the Gatsby's `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.com/docs/quick-start"
      }}>{`Quick Start page`}</a></p>
    {
      /* This default export overrides the default layout ensuring */
    }
    {
      /*  that the FAQ component isn't wrapped by other elements */
    }


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      